export default {"src":"/_next/static/media/customisevoucher.4ec3b9cb.svg","height":28,"width":149,"blurWidth":0,"blurHeight":0};